export default "__VITE_ASSET__3rHjFXOV__"